.validationContainer {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}

.validationRow,
.validUrlText {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.625rem;
	margin-left: 0.125rem;

	& svg {
		color: #0b6f85;
		height: 18px;
		width: 18px;
		flex-shrink: 0;
	}

	& span {
		font-size: 0.875rem;
		font-weight: 400;
		line-height: 1.6;
		color: #757575;
	}
}
